/* eslint-disable max-len */
import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import React from "react";

export interface DisclaimerProps {
    result?: {
        formSchema?: {
            ratePerMonthTitle?: string;
            disclaimer?: {
                textOne?: string;
                textTwo?: string;
                hyperlink?: string;
                hyperlinkText?: string;
            };
        };
    };
}

export const Disclaimer: React.FC<DisclaimerProps> = ({ result }) => (
    <>
        {(result?.formSchema?.disclaimer?.textOne || result?.formSchema?.disclaimer?.textTwo
            || result?.formSchema?.disclaimer?.hyperlinkText) &&
        <Mary.base.Div style={{ marginTop: "20px"}}>
            <Mary.organisms.RTE content={result?.formSchema?.disclaimer?.textOne} />
            <Mary.organisms.RTE content={result?.formSchema?.disclaimer?.textTwo} />
            <Mary.atoms.link.Link link={{
                href: result?.formSchema?.disclaimer?.hyperlink ?? "",
                target: Mary.atoms.link.LinkTarget.BLANK,
            }}>
                <b style={{ color: "#fff" }}>
                    {result?.formSchema?.disclaimer?.hyperlinkText}
                </b>
            </Mary.atoms.link.Link>
        </Mary.base.Div>}
    </>
);
